import React, { useEffect } from "react";

import {Button, Form, FormInstance, Input, Radio, Select} from "antd";
import { useAppSelector } from "../../../../store/hooks";
import { selectAppEntities, selectAppIds } from "../../../../store/community/appsSlice";
import { EntityId } from "@reduxjs/toolkit";
import { filterOption } from "../../../../helpers/FormHelper";

type ParamsType = {
  app_id?: number;
  second_app_id?: number;
  target?: 'content' | 'assets';
}

interface propsInterface {
  params?: ParamsType;
  onFinish: Function;
  form: FormInstance;
  loading: boolean;
}

const _FormFeed = ({ loading, params, onFinish, form }: propsInterface) => {
  const apps = useAppSelector(selectAppEntities);
  const appIds = useAppSelector(selectAppIds);

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const renderAppOption = (id: EntityId) => {
    const item = apps[id];

    if (!item || params?.app_id === id) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.name}>{item.name}</Select.Option>
  }

  const AppSelect = () =>  (
    <Form.Item
      label='From: '
      name='second_app_id'
    >
      <Select
        allowClear
        showSearch
        style={{ width: 220 }}
        filterOption={filterOption}
        placeholder='select app'
      >
        {apps && appIds.map(renderAppOption)}
      </Select>

    </Form.Item>
  )

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="inline"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <AppSelect />

      <Form.Item name='target'>
        <Radio.Group>
          <Radio value='content'>Content</Radio>
          <Radio value='assets'>Assets</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item>
        <Button
          className="v-btn v-btn-primary v-btn-w-auto"
          type="primary"
          htmlType="submit"
          loading={loading}
        >
          Feed
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _FormFeed;
